/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 PRO React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 PRO React using thie file.
 */

const colors = {
  background: {
    default: "#f0f2f5",
  },

  text: {
    main: "#7b809a",
    focus: "#7b809a",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    // main: "#e91e63",
    // focus: "#e91e63",
    main: "#006CEB",
    focus: "#0055B8"
  },

  secondary: {
    // main: "#7b809a",
    // focus: "#8f93a9",
    main: "#0055B8",
    focus: "#003D85"
  },

  info: {
    // main: "#1A73E8",
    // focus: "#1662C4",
    main: "#006CEB",
    focus: "#0055B8"
  },

  success: {
    // main: "#4CAF50",
    // focus: "#67bb6a",
    main: "#008550",
    focus: "#008550",
  },

  warning: {
    main: "#FFA400",
    focus: "#FB8C00",
  },

  error: {
    main: "#DE2F1B",
    focus: "#DE2F1B",
  },

  light: {
    main: "#f0f2f5",
    focus: "#f0f2f5",
  },

  dark: {
    main: "#344767",
    focus: "#2c3c58",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      // main: "#EC407A",
      // state: "#D81B60",
      main: "#006CEB",
      state: "#0055B8"
    },

    secondary: {
      // main: "#747b8a",
      // state: "#495361",
      main: "#0055B8",
      state: "#003D85"
    },

    info: {
      // main: "#49a3f1",
      // state: "#1A73E8",
      main: "#006CEB",
      state: "#0055B8"
    },

    success: {
      main: "#008550",
      state: "#008550",
    },

    warning: {
      main: "#FFA400",
      state: "#FB8C00",
    },

    error: {
      main: "#DE2F1B",
      state: "#DE2F1B",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#003D85",
      state: "#002652"
      // main: "#42424a",
      // state: "#191919",
    },
    jtcprimary: {
      main: "#0063EB",
      state: "#0063EB"
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#008550",
    },

    warning: {
      background: "#ffd59f",
      text: "#FB8C00",
    },

    error: {
      background: "#fcd3d0",
      text: "#DE2F1B",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
